const members = [
    {
        id:1,
        img:'https://res.cloudinary.com/dk4ruyonq/image/upload/v1706718083/Boni_Founder_kdksje.jpg',
        social_links:[
            {link: 'http://facebook.com', target: '_blank', icon: 'icon-facebook'},
            {link: 'http://twitter.com', target: '_blank', icon: 'icon-twitter'},
            {link: 'https://www.linkedin.com/in/boniphace-kanyathare-phd-0582a356/', target: '_blank', icon: 'icon-linkedin2'}
        ],
        name:'Boniphace Kanyathare',
        title:'Founder and CEO',
        delay:'50',
        about_me:'Founder and CEO',
        contact_me:'',
        address:'Finland',
        phone:'+358 (45) 196 4808',
        email:'boniphace@ujuzi.io',
    },
    {
        id:2,
        img:'https://res.cloudinary.com/dk4ruyonq/image/upload/v1706717924/Jesse_CTO_ygmhdo.jpg',
        social_links:[
            {link: 'http://facebook.com', target: '_blank', icon: 'icon-facebook'},
            {link: 'http://twitter.com', target: '_blank', icon: 'icon-twitter'},
            {link: 'https://www.linkedin.com/in/jesse-mwangi/', target: '_blank', icon: 'icon-linkedin2'}
        ],
        name:'Jesse Mwangi',
        title:'Co Founder and CTO',
        delay:'100',
        about_me:"I'm a full-stack developer with over a decade of experience in the IT industry and software development. \nI have a strong passion for software development and a commitment to continuous learning. Over the years, I've attended various workshops and training sessions in Kenya, India, and Finland to enhance my skills",
        contact_me:'',
        address:'Helsinki, Finland',
        phone:'+358 (41) 310 4557',
        email:'jesse@ujuzi.io',
    },
    {
        id:3,
        img:'https://res.cloudinary.com/dk4ruyonq/image/upload/v1706876524/Wende_Luvinga_d6ca03a658.jpg',
        social_links:[
            {link: 'http://facebook.com', target: '_blank', icon: 'icon-facebook'},
            {link: 'http://twitter.com', target: '_blank', icon: 'icon-twitter'},
            {link: 'https://www.linkedin.com/in/jesse-mwangi/', target: '_blank', icon: 'icon-linkedin2'}
        ],
        name:'Wende Luvinga',
        title:'Business Consultant',
        delay:'150',
        about_me:'Wende Luvinga is a business development and sustainability consultant with over 10 years of experience in developing strategies, managing, and implementing,  business projects. She has experience and knowledge of various aspects of business to optimize performance and drive success. Wende has worked with projects for international clients in several countries in Europe and East Africa. As a sustainability consultant, she has experience in guiding businesses to become socially and environmentally responsible.',
        contact_me:'',
        address:'',
        phone:'',
        email:'',
    },
]



export default members;